module.exports = new __parcel__URL__("summary-preview-dark.32dd4d90.svg").toString();